<template>
  <div>
    <!--projects start-->
    <div class="row project light-hover pl-3" v-for="project, project_index in client.projects" v-if="client.projects.length > 0">
      <div class="col align-self-center">
        <span class="m-badge m-badge--metal m-badge--dot"></span>
        {{ project.name }}
        <template v-if="project.fixed_price">
          <span style="text-decoration: underline;">
            <b>Fixed: </b> {{ project.fixed_price }} €
          </span>
        </template>
      </div>
      <div class="col-auto">
        <div class="m-portlet__nav-link btn m-btn m-btn--hover-success m-btn--icon m-btn--icon-only m-btn--pill" title="Info" @click.stop="$refs.projectInfo.open(client, project)">
          <i class="la la-dollar"></i>
        </div>
        <div href="#" class="m-portlet__nav-link btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill" title="Edit" @click="$refs.projectForm.edit(client, project)">
          <i class="la la-pencil"></i>
        </div>
        <div href="#" class="m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete" @click="tryToDestroy(project.id)">
          <i class="la la-times"></i>
        </div>
      </div>
    </div>
    <div class="row project" v-if="client.projects.length == 0">
      <div class="col-12 pl-5">
        No projects
      </div>
    </div>
    <!--projects end-->

    <project-form ref="projectForm" @projectUpdated="updateProject"></project-form>
    <project-info ref="projectInfo"></project-info>

  </div>
</template>
<script>
  import ProjectForm from './ProjectForm'
  import ProjectInfo from './ProjectInfo.vue'

  export default {
    props: ['client'],
    components: {
      'project-form': ProjectForm,
      'project-info': ProjectInfo
    },
    methods: {
      updateProject(project) {
        this.$emit('updateProject', project)
      },
      tryToDestroy(project_id) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You won\'t be able to revert this!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#dd4b39',
          focusCancel: true,
          reverseButtons: true
        }).then(result => {
          if (result.value) {
            this.destroy(project_id)
          }
        })
      },
      destroy(project_id) {
        this.axios.delete('/projects/' + project_id).then(result => {
          if (result.status === 204) {
            this.$emit('destroyProject', project_id)
          }
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/clients/projects/Index.vue